import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import BalanceIcon from '@mui/icons-material/Balance';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import PsychologyIcon from '@mui/icons-material/Psychology';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';
import SavingsIcon from '@mui/icons-material/Savings';
//import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';

const items = [
  {
    icon: <BalanceIcon />,
    title: 'Equitable employee compensation',
    description:
      "Gauge true contribution to the company by understanding the evidence-based impact they had on projects, free from possible manager biases.",
  },
  {
    icon: <PriceCheckIcon />,
    title: 'Price check 3rd party vendors',
    description:
      'Negotiating services from partners and vendors is part of your business. Ignore the sales pitches and promises. Our customers use Orange to track the real numbers during early engagement to calculate an objective ROI.',
  },
  {
    icon: <ReplayCircleFilledIcon />,
    title: 'Replay proven tactics',
    description:
      "Some campaigns are power-hitters, and some... aren't. Orange analyzes every detail of your execution, from staffing structure to timing to project details. Don't just guess based on surface metrics - repeat your wins reliably every time.",
  },
  {
    icon: <SavingsIcon />,
    title: 'Identify cost centers',
    description:
      "Some teams don't generate revenue, but someone said you need them anyway. Now you can understand whether that's really true and in what concrete ways they support the rest of your operation.",
  },
  {
    icon: <PsychologyIcon />,
    title: 'What if..?',
    description:
      'The longer you use Orange, the more it understands how your business responds in various situations. Plug in hypothetical scenarios and your assistant will predict how your organizational units will be affected, and what their reaction to the change may be.',
  },
  {
    icon: <Diversity1Icon />,
    title: 'Assemble dream teams',
    description:
      'With enough data, our AIs begin to learn not only what each your staff excels at, but who they work with best. When a new initiative really matters, let Orange assemble an all-star team that meets your timeline and OKRs',
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: 'grey.900',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography
            component="h2"
            variant="h2"
            gutterBottom
        >
            Use cases
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: 'grey.400', fontSize : '1.3rem' }}
        >
            Just a few of the ways our customers are leveraging Orange AI.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: 'inherit',
                  p: 3,
                  height: '100%',
                  borderColor: 'hsla(220, 25%, 25%, 0.3)',
                  backgroundColor: 'grey.800',
                }}
              >
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography
                    gutterBottom sx={{ fontWeight: 'medium', fontSize: '1.3rem' }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: 'grey.400', fontSize: '1rem' }}
                  >
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
